import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  borderAccent?: 'primary' | 'secondary' | 'tertiary';
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  borderAccent
}) => {
  let borderClass = '';

  if (borderAccent) {
    const borderColors = {
      primary: 'border-l-4 border-[var(--primary)]',
      secondary: 'border-l-4 border-[var(--secondary)]',
      tertiary: 'border-l-4 border-[var(--tertiary)]'
    };
    borderClass = borderColors[borderAccent];
  }

  return (
    <div className={`card ${borderClass} ${className}`}>
      {children}
    </div>
  );
};

export default Card;